var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopCharging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.975 1.66699C5.375 1.66699 1.64166 5.40033 1.64166 10.0003C1.64166 14.6003 5.375 18.3337 9.975 18.3337C14.575 18.3337 18.3083 14.6003 18.3083 10.0003C18.3083 5.40033 14.5833 1.66699 9.975 1.66699ZM8.93333 12.5253C8.93333 12.9253 8.76666 13.0837 8.34166 13.0837H7.25833C6.83333 13.0837 6.66666 12.9253 6.66666 12.5253V7.47533C6.66666 7.07533 6.83333 6.91699 7.25833 6.91699H8.33333C8.75833 6.91699 8.925 7.07533 8.925 7.47533V12.5253H8.93333ZM13.3333 12.5253C13.3333 12.9253 13.1667 13.0837 12.7417 13.0837H11.6667C11.2417 13.0837 11.075 12.9253 11.075 12.5253V7.47533C11.075 7.07533 11.2417 6.91699 11.6667 6.91699H12.7417C13.1667 6.91699 13.3333 7.07533 13.3333 7.47533V12.5253Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopCharging);
export default __webpack_public_path__ + "static/media/stop-charging.78f4e0bd5f4699a0b6d754b3912fa015.svg";
export { ForwardRef as ReactComponent };